import { plainToClass } from 'class-transformer';
import {
  API_LOCATION_CREATE,
  API_LOCATION_DELETE,
  API_LOCATION_FIND_ALL,
  API_LOCATION_FIND_ONE,
  API_LOCATION_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { LocationDto } from '../dto';
import { FindAllResponse } from '../types';

export class LocationApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<LocationDto>> {
    return this.httpClient
      .get(API_LOCATION_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(LocationDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<LocationDto> {
    return this.httpClient
      .get(API_LOCATION_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(LocationDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<LocationDto> {
    return this.httpClient.post(API_LOCATION_CREATE, data).then(({ data }) => {
      return plainToClass(LocationDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<LocationDto> {
    return this.httpClient.put(API_LOCATION_UPDATE, data).then(({ data }) => {
      return plainToClass(LocationDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_LOCATION_DELETE, {
      pathParams: { uuid }
    });
  }
}
